import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { cardClickOutput } from '../shared/components/card-item-list/card-item-list.component';
import { BillCategoryListService } from 'src/app/dashboard/admin/action/components/bill-payments/bill-category/services/bill-category-list.service';
import { Category } from '../interfaces/biller-interfaces'
import { LanguageService } from 'src/app/shared/services/language.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-biller-home-page',
  templateUrl: './biller-home-page.component.html',
  styleUrls: ['./biller-home-page.component.scss']
})
export class BillerHomePageComponent implements OnInit {
  categories: Category;
  constructor(
    private fetchCategoriesList: BillCategoryListService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private languageService: LanguageService,
  ) {
    // if (localStorage.getItem("language")) {
    //   if (localStorage.getItem("language") === "ar") {
    //     translate.use('ar');
    //     document.body.classList.add('dir-rtl');
    //   } else if (localStorage.getItem("language") === "en") {
    //     translate.use('en');
    //     document.body.classList.remove('dir-rtl');
    //   }
    // } else {
    //   translate.use('en');
    //   document.body.classList.remove('dir-rtl');
    // }
   }

  async ngOnInit() {
    this.translate.use(localStorage.getItem("language"));
    this.categories = await this.fetchCategoriesList.make();
  }
  onClickCategory(event) {
    this.router.navigate(['category/'+ event],{relativeTo:this.route});
  }
}
